import type { ActionItem } from '@maker-toolchest/shared';
import { api } from '@/lib/api';

export const actionItemsApi = {
  /**
   * Get all action items for the current tenant
   * Note: The API supports pagination but we fetch the first page (default 20 items)
   * which should be sufficient for most action item use cases
   */
  list: async (): Promise<ActionItem[]> => {
    const response = await api.get<ActionItem[]>('/action-items');
    if (!response.success || !response.data) {
      throw new Error('Failed to fetch action items');
    }
    return response.data;
  },
};
